import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetRelationsModelContextDocument,
  type GetRelationsModelContextQuery,
  type GetRelationsModelContextQueryVariables,
} from "~/features/relations/gqls";
import { useTenant } from "~/features/tenant/context";

/** Lookup data for the search sidebar: relation categories + references. */
export function useRelationModelContext() {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  const { data } = useSuspenseQuery<GetRelationsModelContextQuery, GetRelationsModelContextQueryVariables>(
    GetRelationsModelContextDocument,
    { variables: { tenantId } },
  );
  return { relationCategories: data.relationCategories, references: data.references };
}
